// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d39ba769","239":"fcf2c871","455":"2728ebd2"}[chunkId] + ".chunk.js";
};